import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import BackgroundImage from "gatsby-background-image"
import { isMobileOnly } from "react-device-detect"

import MapaStacji from "../../images/mapa-stacji.svg"

const query = graphql`
  {
    fotka: file(relativePath: { eq: "img2.jpg" }) {
      childImageSharp {
        fluid(quality: 60) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`

const SideMapa = () => {
    const data = useStaticQuery(query)


    return (
      <BackgroundImage
        Tag="section"
        className={`col-12 col-lg-6 side-2`}
        fluid={data.fotka.childImageSharp.fluid}
        backgroundColor={`#000`}
      >
        <div className="bg-overlay"></div>
        <div
          data-sal={!isMobileOnly ? "slide-up" : ""}
          data-sal-delay="700"
          data-sal-duration="600"
          data-sal-easing="ease"
          className="box p-3 p-md-5 ie11animfix"
        >
          <a
            href="https://www.orlen.pl/pl/dla-ciebie/stacje?kw=&from=&to=&s=1669&wp=&dst=0"
            target="_blank"
            rel="noreferrer"
            title="Znajdź naszą ładowarkę"
          >
            <div className="box-title">MAPA STACJI</div>
            <p>
              <img
                src={MapaStacji}
                alt=""
                width="370" height="205"
                className="img-fluid mb-3 ie11-fix1"
              />
            </p>
            <span className="link-more">Znajdź naszą ładowarkę</span>
          </a>
        </div>
      </BackgroundImage>
    )
}


export default SideMapa

